module.exports = __webpack_public_path__ + "media/safetyindex.3a98ba82.webm";